document.addEventListener('DOMContentLoaded', function(){
  var q = document.querySelector('.product-form__quantity .quantity__input');
  if (q){ q.value=''; q.defaultValue=''; }
});

(function(){
  const $ = (sel, root=document) => root.querySelector(sel);
  const $$ = (sel, root=document) => Array.from(root.querySelectorAll(sel));

  const parseMoney = (val) => {
    if (val == null) return NaN;
    if (typeof val === 'number') return val;
    return parseFloat(String(val).replace(/[^\d.]/g, ''));
  };

  const fmt = (n, sym='£') => sym + Number(n).toFixed(2);

  // Always round UP to next penny
  const roundUp2 = (n) => Math.ceil((Number(n) - 0.0000001) * 100) / 100;

  function discountedUnitFromLine(unitPrice, qty, pct){
    const rawUnit = unitPrice * (1 - pct / 100);
    return roundUp2(rawUnit);
  }

  const excWrapSel       = '.product__info-container .f-price-item.f-price-item--sale';
  const incWrapSel       = '.product__info-container .vat_text.f-price-item.f-price-item--sale';
  const qtySel           = '.product-form__quantity .quantity__input';
  const hulkTableSel     = '.hulkapps-table';
  const originalPriceSel = '.custom_original_price';

  const state = { base:null, tiers:null, lowestAbs:null, ready:false, originalBase:null };

  function getCurrentVariantId(){
    const variantInput = document.querySelector('input[name="id"], select[name="id"], form[action*="/cart/add"] [name="id"]');
    return variantInput ? variantInput.value : null;
  }

  function readOriginalBasePrice(){
    const variantId = getCurrentVariantId();
    if (!variantId || !window.variantOriginalPrices) return null;
    return parseMoney(window.variantOriginalPrices[variantId]);
  }

  function setOriginalPrice(price){
    const el = $(originalPriceSel);
    if (!el || price == null || isNaN(price)) return;
    el.textContent = fmt(price, state.base?.sym || '£');
  }

  function readBasePrices(){
    const excWrap = $(excWrapSel);
    const incWrap = $(incWrapSel);
    if (!excWrap) return null;

    let exc = parseMoney(excWrap.dataset.price) || parseMoney(excWrap.textContent);
    let inc = incWrap ? (parseMoney(incWrap.dataset.price) || parseMoney(incWrap.textContent)) : exc;

    const symMatch = (excWrap.textContent.match(/[£$€]/) || (incWrap && incWrap.textContent.match(/[£$€]/)) || ['£']);
    const sym = symMatch[0];
    return { exc, inc, sym };
  }

  function writeHTML(target, priceText){
    const slot = target.querySelector('.excPrice, .incPrice');
    if (slot) slot.innerHTML = priceText;
    else target.innerHTML = priceText;
  }

  function setDisplayed(exc, inc){
    const excWrap = $(excWrapSel);
    const incWrap = $(incWrapSel);
    if (!excWrap) return;
    writeHTML(excWrap, fmt(exc, state.base.sym));
    if (incWrap) writeHTML(incWrap, fmt(inc, state.base.sym));
  }

  function setFrom(exc, inc){
    const excWrap = $(excWrapSel);
    const incWrap = $(incWrapSel);
    if (!excWrap) return;
    const fromPrefix = '<span class="vat_text">from </span>';
    writeHTML(excWrap, fromPrefix + fmt(exc, state.base.sym));
    if (incWrap) writeHTML(incWrap, fromPrefix + fmt(inc, state.base.sym));
  }

  function parseTiers(){
    const table = $(hulkTableSel);
    if (!table) return;
    const rows = $$('tbody tr', table);
    if (!rows.length) return;

    const tiers = [];
    let lowestAbs = Infinity;
    let hasMoney = false;

    for (const tr of rows){
      const rangeCell = $('td:first-child', tr);
      if (!rangeCell) continue;
      const rangeTxt = rangeCell.textContent.trim();

      let min = 0;
      if (rangeTxt.includes('–')){
        const m = parseInt(rangeTxt.split('–')[0], 10);
        if (!isNaN(m)) min = m;
      } else if (rangeTxt.includes('-')){
        const m = parseInt(rangeTxt.split('-')[0], 10);
        if (!isNaN(m)) min = m;
      } else {
        const m = parseInt(rangeTxt.replace('+',''), 10);
        if (!isNaN(m)) min = m;
      }

      const pctNode = tr.querySelector('.hulkapps-price');
      if (pctNode && /%/.test(pctNode.textContent)){
        const pct = parseFloat(pctNode.textContent);
        if (!isNaN(pct)) tiers.push({ min, pct });
      } else {
        const lastCell = tr.querySelector('td:last-child');
        if (lastCell && /%/.test(lastCell.textContent)){
          const pct = parseFloat(lastCell.textContent);
          if (!isNaN(pct)) tiers.push({ min, pct });
        }
      }

      const moneyMatch = tr.textContent.match(/[£$€]\s*\d[\d,]*(?:\.\d+)?/g);
      if (moneyMatch){
        for (const m of moneyMatch){
          const val = parseFloat(m.replace(/[^\d.]/g,''));
          if (val > 0 && val < lowestAbs){
            hasMoney = true;
            lowestAbs = val;
          }
        }
      }
    }

    if (tiers.length){
      tiers.sort((a,b)=> a.min - b.min || b.pct - a.pct);
      const collapsed = [];
      let seenMin = new Set();
      for (const t of tiers){
        if (!seenMin.has(t.min)){
          collapsed.push(t);
          seenMin.add(t.min);
        }
      }
      state.tiers = collapsed;
    } else {
      state.tiers = [];
    }

    state.lowestAbs = hasMoney && isFinite(lowestAbs) ? lowestAbs : null;
    state.ready = true;
  }

  function bestPercentFor(qty){
    if (!state.tiers || !state.tiers.length) return 0;
    let best = 0;
    for (const t of state.tiers){
      if (qty >= t.min && t.pct > best) best = t.pct;
    }
    return best;
  }

  let rafId = null;
  function recalc(){
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(()=>{
      const qtyInput = $(qtySel);
      if (!qtyInput) return;

      const raw = qtyInput.value;
      const qty = raw === '' ? 0 : (parseInt(raw, 10) || 0);

      const base = state.base || (state.base = readBasePrices());
      if (!base || isNaN(base.exc) || isNaN(base.inc)) return;

      if (state.originalBase == null || isNaN(state.originalBase)) {
        state.originalBase = readOriginalBasePrice();
      }

      if (raw === '' || qty === 0) {
        setOriginalPrice(state.originalBase);
        return;
      }

      const pct = bestPercentFor(qty);

      if (pct > 0){
        const excUnit = discountedUnitFromLine(base.exc, qty, pct);
        const incUnit = discountedUnitFromLine(base.inc, qty, pct);

        setDisplayed(excUnit, incUnit);

        if (state.originalBase != null && !isNaN(state.originalBase)) {
          const originalUnit = discountedUnitFromLine(state.originalBase, qty, pct);
          setOriginalPrice(originalUnit);
        }
      } else {
        setDisplayed(base.exc, base.inc);
        if (state.originalBase != null && !isNaN(state.originalBase)) {
          setOriginalPrice(state.originalBase);
        }
      }
    });
  }

  function showFromOnce(){
    const base = state.base || (state.base = readBasePrices());
    if (!base) return;

    if (state.tiers && state.tiers.length){
      const maxPct = state.tiers.reduce((m,t)=> Math.max(m, t.pct || 0), 0);
      if (maxPct > 0){
        setFrom(
          discountedUnitFromLine(base.exc, 1, maxPct),
          discountedUnitFromLine(base.inc, 1, maxPct)
        );
      } else {
        setFrom(base.exc, base.inc);
      }
    } else if (state.lowestAbs){
      setFrom(state.lowestAbs, state.lowestAbs);
    } else {
      setFrom(base.exc, base.inc);
    }

    state.originalBase = readOriginalBasePrice();
    setOriginalPrice(state.originalBase);
  }

  function init(){
    state.base = readBasePrices();
    state.originalBase = readOriginalBasePrice();
    state.tiers = null;
    state.lowestAbs = null;
    state.ready = false;

    const qty = $(qtySel);
    if (qty){
      qty.value = '';
      qty.defaultValue = '';
      qty.setAttribute('placeholder','');
    }

    const table = $(hulkTableSel);
    if (table && !state.ready) parseTiers();
    if (state.ready) showFromOnce();

    if (!state.ready){
      const target = table || document.body;
      const mo = new MutationObserver(()=>{
        const t = $(hulkTableSel);
        if (t && t.querySelector('tbody tr')){
          parseTiers();
          showFromOnce();
          mo.disconnect();
        }
      });
      mo.observe(target, { childList:true, subtree:true });
      setTimeout(()=>{
        if (!state.ready && $(hulkTableSel)) {
          parseTiers();
          showFromOnce();
        }
      }, 1000);
    }
  }

  document.addEventListener('input', function(e){
    if (e.target && e.target.matches(qtySel)) recalc();
  }, { passive:true });

  document.addEventListener('click', function(e){
    const btn = e.target.closest('.product-form__quantity .quantity__button');
    if (!btn) return;
    setTimeout(recalc, 0);
  });

  document.addEventListener('change', function(e){
    if (e.target && e.target.matches('input[name="id"], select[name="id"], variant-selects select, variant-radios input')) {
      setTimeout(init, 120);
    }
  });

  ['variant:change','variant:changed','product:variant-change'].forEach(ev=>{
    document.addEventListener(ev, function(){
      setTimeout(init, 120);
    }, true);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();